import { render } from "./FormRowHeader.vue?vue&type=template&id=4059d0a5&scoped=true"
import script from "./FormRowHeader.vue?vue&type=script&lang=js"
export * from "./FormRowHeader.vue?vue&type=script&lang=js"

import "./FormRowHeader.vue?vue&type=style&index=0&id=4059d0a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4059d0a5"]])

export default __exports__